<h2 mat-dialog-title>Nicht verfügbare Artikel</h2>

<mat-dialog-content>
  <ui-order-unavailable-products
    [showActions]="false"
    [unavailableProductsErrors]="data.unavailableProductsErrors">
  </ui-order-unavailable-products>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <ui-button buttonStyle="text" (click)="close()">Schließen</ui-button>
  <ui-button buttonStyle="filled" (click)="deleteAndOrder()">Löschen und Bestellen</ui-button>
</mat-dialog-actions>
